export default {
  populate: {
    booking_items: {
      populate: {
        accommodation: {
          populate: "localizations",
        },
        rate_plan: {
          populate: "localizations",
          fields: "name",
        },
        treatment: true,
        prezziario: true,
      },
    },
    booking_payments: true,
    user: true,
    facility: true,
    coupon: {
      populate: "localizations",
    },
  },
};
